// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1_OD8","cls2":"RecommendedPodcastBadge-cls2__gS RecommendedPodcastBadge-cls1_OD8"};